<script setup lang="ts">
import { ElSwitch } from 'element-plus'

/**
 * One boolean as a toggle. `Checkbox` is the same value in a form's own voice; this one
 * is for a state that reads as on/off and is flipped where it applies — inside the field
 * it unlocks, beside the row it governs.
 *
 * The texts sit beside the track (`activeText` / `inactiveText`), which is where Element
 * Plus draws them; `inlineText` moves them inside it for a switch with no room next to it.
 */
withDefaults(
  defineProps<{
    modelValue?: boolean
    activeText?: string
    inactiveText?: string
    inlineText?: boolean
    disabled?: boolean
    loading?: boolean
    size?: 'large' | 'default' | 'small'
  }>(),
  { modelValue: false, inlineText: false }
)

const emit = defineEmits<{
  (e: 'update:modelValue', value: boolean): void
  (e: 'change', value: boolean): void
}>()
</script>

<template>
  <ElSwitch
    :model-value="modelValue"
    :active-text="activeText"
    :inactive-text="inactiveText"
    :inline-prompt="inlineText"
    :disabled="disabled"
    :loading="loading"
    :size="size"
    v-bind="$attrs"
    @update:model-value="emit('update:modelValue', Boolean($event))"
    @change="emit('change', Boolean($event))"
  />
</template>
